import * as React from 'react';
import Container from '@mui/material/Container';
import { Alert } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { useQuery } from '@apollo/client';
import RequestSearch from '../../components/common/SearchText';
import { graphql } from '../../__generated__';
import ServiceList from './ServiceList';

export const getServicesQuery = graphql(`
  query GetServices {
    services {
      serviceid
      merchant
      title
      description
      category
      type
      status
      labelCustomerNumber {
        localText
      }
      labelServiceNumber {
        localText
      }
    }
  }
`);

const Services = () => {
  const [text, setText] = React.useState<string>('');
  const onValueChange = (value: string) => {
    setText(value);
  };
  const { data, loading, error, refetch } = useQuery(getServicesQuery);

  return (
    <Container fixed>
      <Box m={0}>
        <RequestSearch
          placeholderText="Search..."
          value={text}
          onValueChange={onValueChange}
          onClear={() => setText('')}
        />
      </Box>
      {loading && (
        <Box m={1}>
          <LinearProgress />
        </Box>
      )}
      {error && (
        <Alert severity="error" onClose={() => refetch()}>
          {error?.message || 'An error occured'}
        </Alert>
      )}
      {data && <ServiceList query={data} loading={loading} searchText={text} />}
    </Container>
  );
};

export default Services;
